import {fadeIn, fadeOut} from "@/utils/utils"


export default class BasePopup {

    #id;

    constructor(id) {
        this.#id = id
        this.#basePopupInit()
    }


    // getters

    get id() {
        return this.#id
    }


    // private methods

    #getBasePopupTemplate() {
        return `
        <div id="${this.#id}" class="popup-wrapper position-fixed justify-content-center align-items-start mx-5"
            style="display: none;">
            <div class="popup container px-0 px-md-2">
                <div class="popup-content container px-0 px-md-2 mb-md-5">

                </div>
            </div>
        </div>
    `
    }
    #injectBasePopupHTML() {
        if (document.querySelector(`#${this.#id}`)) {
            document.querySelector(`#${this.#id}`).remove()
        }
        document.body.insertAdjacentHTML('beforeend', this.#getBasePopupTemplate())
    }

    #setBasePopupListeners() {
        this.getOverlay().addEventListener("click", ()=>{this.hide()})
    }
    #basePopupInit() {
        this.#injectBasePopupHTML()
        this.#setBasePopupListeners()
    }


    // public methods
    
    // unfortunately vanilla JS classes are not that advanced, 
    // so child classes cannot access private methods of classes they are extending
    // therefore I had to make some classes that were intended to be private - public.
    
    getOverlay() {
        return document.querySelector('#tf-overlay')
    }
    getRootDiv() {
        return document.querySelector(`#${this.#id}`)
    }
    getPopupContentDiv() {
        return this.getRootDiv().querySelector('.popup-content')
    }

    injectContentHTML(html){
        this.getPopupContentDiv().innerHTML=''
        this.getPopupContentDiv().insertAdjacentHTML("beforeend", html)
    }

    display(e) {
        e && e.preventDefault()
        
        document.body.classList.add('overflow-hidden')
        fadeIn(this.getOverlay(), "block")
        fadeIn(this.getRootDiv(), "block")
    }
    hide() {
        document.body.classList.remove('overflow-hidden')
        fadeOut(this.getOverlay())
        fadeOut(this.getRootDiv())
    }

}